/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Durationdays1Inputs */

const en_durationdays1 = /** @type {(inputs: Durationdays1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (days)`)
};

const de_durationdays1 = /** @type {(inputs: Durationdays1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer (Tage)`)
};

/**
* | output |
* | --- |
* | "Duration (days)" |
*
* @param {Durationdays1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const durationdays1 = /** @type {((inputs?: Durationdays1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Durationdays1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_durationdays1(inputs)
	return de_durationdays1(inputs)
});
export { durationdays1 as "durationDays" }